<template>
  <div v-if="items.length > 0" class="d-flex align-center flex-wrap">
    <v-chip
      v-for="(item, index) in items.slice(0, limit)"
      small
      color="blue-grey lighten-3"
      class="chip caption blue-grey--text text--darken-3 me-1 cursor-default"
      :outlined="outlined"
      :class="validationsTable ? 'mb-2' : 'mb-1'"
      :key="`${item}${index}`"
    >
      {{ item }}
    </v-chip>
    <template v-if="itemsLength > limit">
      <v-menu :open-on-hover="openOnHover">
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            v-bind="attrs"
            v-on="on"
            small
            color="blue-grey lighten-3"
            class="caption blue-grey--text text--darken-3 cursor-default"
            :outlined="outlined"
            :class="validationsTable ? 'mb-2' : 'mb-1'"
            @click.stop="$emit('click')"
          >
            +{{ itemsLength - limit }}
          </v-chip>
        </template>

        <v-card
          class="ma-0 pa-0 blue-grey lighten-3 px-4 pt-4 pb-1 item-detail"
          dense
          elevation="2"
        >
          <p
            v-for="(item, index) in itemsToShow"
            class="ma-0 pa-0 label mb-3 blue-grey--text text--darken-2 font-weight-400"
            :key="`${item}${index}`"
          >
            {{ item }}
          </p>
        </v-card>
      </v-menu>
    </template>
  </div>
  <p v-else class="ma-0 pa-0 blue-grey--text text-start text--darken-1">-</p>
</template>

<script>
export default {
  name: 'ChipList',

  props: {
    menuItems: Array,
    totalItems: Number,
    items: {
      type: Array,
      required: true,
    },
    limit: {
      type: Number,
      required: false,
      default: 1,
    },
    validationsTable: {
      required: false,
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    openOnHover: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    itemsLength() {
      return this.totalItems ?? this.items.length
    },
    itemsToShow() {
      return this.menuItems ?? this.items?.slice(this.limit)
    },
  },
}
</script>
<style lang="scss">
.item-detail {
  max-height: 250px;
  overflow-y: scroll;
  border: 1px solid $color-blue-grey-lighten1 !important;
}
.chip:before {
  background-color: inherit !important;
  cursor: default;
}
</style>
